<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">Te factureren (Projecten) <span v-if="hidden === true">(Verborgen)</span></h2>
                <div class="box-tools">
                    <button class="btn btn-default"
                        v-if="hidden === false"
                        @click="hidden = true"
                    >Verborgen regels weergeven</button>
                    <button class="btn btn-default"
                        v-else
                        @click="hidden = false"
                    >Nog te realiseren regels weergeven</button>


                    <div class="btn-group btn-group-sm">
                        <json-excel
                            :data="getToInvoiceJSONData"
                            :disabled="getToInvoiceJSONData.length === 0"
                            :name="getExportName()"
                            v-tooltip="'Exporteren naar Excel'"
                            class="btn btn-default"
                        >
                            <i class="mdi mdi-file-excel-box"></i>
                        </json-excel>
                        <button
                            class="btn btn-default"
                            @click="exportToPdf()"
                            v-tooltip="'Exporteren naar PDF'"
                        >
                            <i class="mdi mdi-file-pdf-box"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="box-body no-padding">
                <table class="table table-striped table-hover table-bordered" id="toinvoice-table">
                    <thead>
                        <tr>
                            <th>Project</th>
                            <th>Taak</th>
                            <th class="text-right">Totaal factureren</th>
                            <th class="text-right">Verzonden facturen</th>
                            <th class="text-right">Ingeplande facturen</th>
                            <th class="text-right">Nog te factureren</th>
                            <th v-if="hidden === true">Reden verborgen</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="toInvoice.length === 0"><td colspan="8">Er zijn geen taken te factureren</td></tr>
                        <tr v-for="task in toInvoice">
                            <td>
                                <a :href="task.paths.projecturl">
                                    {{ task.project }}
                                </a>
                            </td>
                            <td>
                                <a :href="task.paths.taskurl">
                                    {{ task.task }}
                                </a>
                            </td>
                            <td class="text-right">{{ task.total | toCurrency }}</td>
                            <td class="text-right">{{ task.send_invoices | toCurrency }}</td>
                            <td class="text-right">{{ task.remaining_invoices | toCurrency }}</td>
                            <td class="text-right">{{ task.toinvoice | toCurrency }}</td>
                            <td v-if="hidden === true">{{ task.toinvoice_hidden_description }}</td>
                            <td class="text-right">
                                <div class="btn-group btn-group-xs">
                                    <button type="button" class="btn btn-primary"
                                        v-tooltip="'Regel verbergen'"
                                        v-if="hidden === false"
                                        @click="openModal(task)"
                                    ><i class="mdi mdi-eye-off"></i></button>
                                    <button type="button" class="btn btn-primary"
                                        v-tooltip="'Regel niet meer verbergen'"
                                        v-else
                                        @click="openModal(task)"
                                    ><i class="mdi mdi-eye"></i></button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="5" class="text-right">Totaal nog te factureren:</th>
                            <th class="text-right">{{ totalToInvoice | toCurrency }}</th>
                            <th>&nbsp;</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="overlay" v-if="loading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <div class="modal fade" id="toInvoiceHideModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="mdi mdi-close"></i></span></button>
                        <h4 class="modal-title" v-if="hidden === false">Regel verbergen</h4>
                        <h4 class="modal-title" v-else>Regel niet meer verbergen</h4>
                    </div>
                    <div class="modal-body">
                        <div v-if="hidden === false">
                            <p>Met deze actie wordt deze taak ({{ actionTask.task }}) verborgen van het overzicht. Vul hieronder de reden in van het verbergen.</p>
                            <textarea class="form-control" v-model="hideReason" placeholder="Voer hier de reden van het verbergen in"></textarea>
                        </div>
                        <div v-else>
                            <p>Met deze actie wordt deze taak ({{ actionTask.task }}) weer gepresenteerd in het overzicht.</p>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="row">
                            <div class="col-sm-6 text-left">
                                <button @click="close()" class="btn btn-sm btn-default">{{ lang.get("global.no") }}</button>
                            </div>
                            <div class="col-sm-6">
                                <button @click="fire()" class="btn btn-sm btn-primary">{{ lang.get("global.yes") }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import Lang from '../../Lang';
import jsPDF from 'jspdf';
import moment from 'moment';
import JsonExcel from 'vue-json-excel';

export default {

    components: {
        JsonExcel,
    },

    computed: {
        getToInvoiceJSONData() {
            return this.toInvoice.map((invoice) => {
                return {
                    project: invoice.project,
                    task: invoice.task,
                    total_to_invoice: invoice.total,
                    total_invoiced: invoice.send_invoices,
                    total_remaining: invoice.remaining_invoices,
                    still_to_invoice: invoice.toinvoice,
                };
            });
        },

        totalToInvoice() {
            let total = 0;
            this.toInvoice.forEach(task => total += task.toinvoice);
            return total;
        },
    },

    data() {
        return {
            actionTask:{},
            hidden:false,
            hideReason:'',
            lang:Lang,
            loading:true,
            toInvoice:[],
        }
    },

    methods: {
        close() {
            $('#toInvoiceHideModal').modal('hide');
        },

        exportToPdf() {
            let doc = new jsPDF({orientation:'landscape'});
            let style = {fontSize:7};
            doc.autoTable({
                html:'#toinvoice-table',
                bodyStyles: style,
                footStyles: style,
            });
            doc.save(this.getExportName() + '.pdf');
        },

        getExportName() {
            return 'invoices-open-' + moment().format('YYYY-MM-DD-HH-mm');
        },

        fire() {
            if (!this.actionTask.paths.hideurl) {
                return;
            }
            this.loading = true;
            axios.post(this.actionTask.paths.hideurl, {reason:this.hideReason})
                .then(() => {
                    this.toInvoice.splice(this.toInvoice.findIndex(inv => inv.uuid === this.actionTask.uuid), 1);
                    this.$snotify.success('De taak is verborgen');

                    this.hideReason = '';
                    this.actionTask = {};
                    this.close();
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het verbergen van de taak'))
                .finally(() => this.loading = false);
        },

        getToInvoice() {
            axios.get(this.route(this.hidden === true ? 'api.v1.financial.toinvoice.hidden' : 'api.v1.financial.toinvoice.index'))
                .then(resp => {
                    this.toInvoice = resp.data.data;
                    this.loading = false;
                })
                .catch(() => this.$snotify.error("Er is een fout opgetreden bij het ophalen van de gegevens"));
        },

        openModal(task) {
            this.actionTask = task;
            $('#toInvoiceHideModal').modal('show');
        },

    },

    mounted() {
        this.getToInvoice();
    },

    name:"BusinessToInvoice",

    watch: {
        hidden: function() {
            this.hideReason = '';
            this.actionTask = {};
            this.toInvoice = [];
            this.loading = true;
            this.getToInvoice();
        },
    },

}

</script>
